export const CreditCardOnlyNotice = () => {
  return (
    <>
      ※ 운전자 본인 명의의 신용카드로만 결제가 가능합니다.<br/>
      (현금불가)
    </>
  )
}